import { createActions, createReducer } from "reduxsauce";

/* INITIAL STATE */
export const INITIAL_STATE = {
  list: {
    data: [],
    loading: false,
    success: false,
    error: null,
  },

  create: {
    data: null,
    loading: false,
    success: false,
    error: null,
  },

  update: {
    data: null,
    loading: false,
    success: false,
    error: null,
  },
};

/* ACTIONS */
const { Types, Creators } = createActions(
  {
    // FETCH
    getPromoCodes: ["resolve"],
    getPromoCodesRequest: null,
    getPromoCodesSuccess: ["data"],
    getPromoCodesFailure: ["error"],

    // CREATE
    createPromoCode: ["payload", "resolve"],
    createPromoCodeRequest: null,
    createPromoCodeSuccess: ["data"],
    createPromoCodeFailure: ["error"],

    // UPDATE
    updatePromoCode: ["id", "payload", "resolve"],
    updatePromoCodeRequest: null,
    updatePromoCodeSuccess: ["data"],
    updatePromoCodeFailure: ["error"],
  },
  { prefix: "cb/admin/promoManager/" }
);

export const types = Types;
export const actions = Creators;

/* REDUCERS */

// FETCH
const fetchRequest = (state) => ({
  ...state,
  list: {
    ...state.list,
    loading: true,
    success: false,
    error: null,
  },
});

const fetchSuccess = (state, { data }) => ({
  ...state,
  list: {
    data,
    loading: false,
    success: true,
    error: null,
  },
});

const fetchFailure = (state, { error }) => ({
  ...state,
  list: {
    ...state.list,
    loading: false,
    success: false,
    error,
  },
});

// CREATE
const createRequest = (state) => ({
  ...state,
  create: {
    data: null,
    loading: true,
    success: false,
    error: null,
  },
});

const createSuccess = (state, { data }) => ({
  ...state,
  create: {
    data,
    loading: false,
    success: true,
    error: null,
  },
});

const createFailure = (state, { error }) => ({
  ...state,
  create: {
    data: null,
    loading: false,
    success: false,
    error,
  },
});

// UPDATE
const updateRequest = (state) => ({
  ...state,
  update: {
    data: null,
    loading: true,
    success: false,
    error: null,
  },
});

const updateSuccess = (state, { data }) => ({
  ...state,
  update: {
    data,
    loading: false,
    success: true,
    error: null,
  },
});

const updateFailure = (state, { error }) => ({
  ...state,
  update: {
    data: null,
    loading: false,
    success: false,
    error,
  },
});

/* HANDLERS */
export const HANDLERS = {
  [Types.GET_PROMO_CODES_REQUEST]: fetchRequest,
  [Types.GET_PROMO_CODES_SUCCESS]: fetchSuccess,
  [Types.GET_PROMO_CODES_FAILURE]: fetchFailure,

  [Types.CREATE_PROMO_CODE_REQUEST]: createRequest,
  [Types.CREATE_PROMO_CODE_SUCCESS]: createSuccess,
  [Types.CREATE_PROMO_CODE_FAILURE]: createFailure,

  [Types.UPDATE_PROMO_CODE_REQUEST]: updateRequest,
  [Types.UPDATE_PROMO_CODE_SUCCESS]: updateSuccess,
  [Types.UPDATE_PROMO_CODE_FAILURE]: updateFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);